// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"2e718c50","453":"39ab5e4e","580":"7024160e"}[chunkId] + ".chunk.js";
};